import React from 'react';
import PropTypes from 'prop-types';
import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import {findSbsByTitleSearch} from 'Sbs/service/SbsService';

export default function SelectSbs(props) {
  const {value, onChange, label, ...restProps} = props;
  const getOptionLabel = (option) => option.title || '';

  return (
    <SelectEntity
      queryOnSearch
      getOptionLabel={getOptionLabel}
      getEntities={findSbsByTitleSearch}
      value={value}
      onChange={onChange}
      label={label}
      {...restProps}
    />
  );
}

SelectSbs.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
  }),

  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

SelectSbs.defaultProps = {
  value: [],
  id: null,
  name: null,
  label: 'SBS',
  placeholder: '',
};
